import React from 'react';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';

import './GuaranteedMinimumDetailCard.scss';

const { block, element } = bem('guaranteed-minimum-detail-card');

const GuaranteedMinimumDetailCard = ({ badgeNumber, children, illustration }) => (
  <div className={block()}>
    <div className={element('header')}>
      <div aria-hidden className={element('badge')}>
        {badgeNumber}
      </div>
      <div className={element('copy')}>{children}</div>
    </div>
    {illustration}
  </div>
);

GuaranteedMinimumDetailCard.propTypes = {
  badgeNumber: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.node.isRequired,
};

export default GuaranteedMinimumDetailCard;
